import {EntityModel} from "@fedeltapointofsale/data-client";
import {ProductContainerData} from "./product-container.data";
import {Injectable, Injector} from "@angular/core";

@Injectable()
export class ProductContainerEntityModel extends EntityModel<ProductContainerData> {
    constructor(injector: Injector) {
        super(injector, ProductContainerData);
    }
}
